import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MaterialModule } from './material/material.module';
import 'hammerjs';


import { AppComponent } from './app.component';
import { ErrorHandlerComponent } from './components/shared/error-handler/error-handler.component';
import { LoginComponent } from './components/authentication/login/login.component';
import { LoaderComponent } from './components/shared/loader/loader.component';
import { NavigationComponent } from './components/shared/navigation/navigation.component';
import { LayoutComponent } from './components/layout/layout.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { UserProfileComponent } from './components/shared/user-profile/user-profile.component';
import { NotificationsComponent } from './components/shared/notifications/notifications.component';
import { CoreInterceptor } from './interceptors/core.interceptor';
import { AuthLayoutComponent } from './components/authentication/auth-layout/auth-layout.component';
import { ConfirmComponent } from './components/dialogs/confirm/confirm.component';
import { CascadeConfirmationComponent } from './components/dialogs/cascade-confirmation/cascade-confirmation.component';
import { AddInventoryComponent } from './components/inventory/add-inventory/add-inventory.component';
import { UpdateInventoryComponent } from './components/inventory/update-inventory/update-inventory.component';
import { RuleListComponent } from './components/rules/rule-list/rule-list.component';
import { RuleDetailComponent } from './components/rules/rule-detail/rule-detail.component';
import { DeviceInventoryComponent } from './components/device-management/device-inventory/device-inventory.component';
import { DeviceInventoryListComponent } from './components/device-management/device-inventory/list/device-inventory-list.component';
import { MoveDeviceDialogComponent } from './components/device-management/device-inventory/move-device-dialog/move-device-dialog.component';
import { UploadDialogComponent } from './components/device-management/device-inventory/upload-dialog/upload-dialog.component';
import { CustomerDetailsDialogComponent } from './components/device-management/device-inventory/customer-details-dialog/customer-details-dialog.component';
import { AssociateConfirmationDialogComponent } from './components/device-management/device-inventory/associate-confirmation-dialog/associate-confirmation-dialog.component';
import { CustomerDetailsComponent } from './components/customer-details/customer-details.component';
import { CustomerEditComponent } from './components/customer-edit/customer-edit.component';
import { CustomerListComponent } from './components/customer-list/customer-list.component';
import { CustomerInfoComponent } from './components/shared/customer-info/customer-info.component';
import { RegionsManagerComponent } from './components/shared/regions-manager/regions-manager.component';
import { SitesManagerComponent } from './components/shared/sites-manager/sites-manager.component';
import { CustomerFormComponent } from './components/shared/customer-form/customer-form.component';
import { EditableSectionComponent } from './components/shared/editable-section/editable-section.component';
import { DataDisplayComponent } from './components/shared/data-display/data-display.component';
import { CustomerInfoEditDialogComponent } from './components/dialogs/customer-info-edit-dialog/customer-info-edit-dialog.component';
import { AddRegionOrSiteDialogComponent } from './components/dialogs/addRegionOrSiteDialog/add-region-or-site-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { AddUserDialogComponent } from './components/dialogs/addUserDialog/add-user-dialog.component';
import { UserInfoDialogComponent } from './components/dialogs/user-info-dialog/user-info-dialog.component';


@NgModule({
  declarations: [
    AppComponent,
    ErrorHandlerComponent,
    LoaderComponent,
    AuthLayoutComponent,
    LoginComponent,
    NavigationComponent,
    LayoutComponent,
    HeaderComponent,
    UserProfileComponent,
    NotificationsComponent,
    ConfirmComponent,
    CascadeConfirmationComponent,
    AddInventoryComponent,
    UpdateInventoryComponent,
    RuleListComponent,
    RuleDetailComponent,
    DeviceInventoryComponent,
    DeviceInventoryListComponent,
    MoveDeviceDialogComponent,
    UploadDialogComponent,
    CustomerDetailsDialogComponent,
    AssociateConfirmationDialogComponent,
    CustomerDetailsComponent,
    CustomerEditComponent,
    CustomerListComponent,
    CustomerInfoComponent,
    RegionsManagerComponent,
    SitesManagerComponent,
    CustomerFormComponent,
    EditableSectionComponent,
    DataDisplayComponent,
    CustomerInfoEditDialogComponent,
    AddRegionOrSiteDialogComponent,
    AddUserDialogComponent,
    UserInfoDialogComponent
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ToastrModule.forRoot({ timeOut: 0, positionClass: 'toast-top-center', preventDuplicates: true }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    MaterialModule,
    FontAwesomeModule,
    HttpClientModule,
    MatIconModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CoreInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmComponent,
    CascadeConfirmationComponent,
    MoveDeviceDialogComponent,
    UploadDialogComponent,
    CustomerDetailsDialogComponent,
    AssociateConfirmationDialogComponent,
    CustomerInfoEditDialogComponent,
    AddRegionOrSiteDialogComponent,
    AddUserDialogComponent,
    UserInfoDialogComponent
  ]
})
export class AppModule { }